/* ============================================================
   HANLABAN THEME FIXES v2 - swatch painter + card interactions
   1. Paints fashion color names to real hexes (no blank circles)
   2. Clickable card swatches: swap card image + retarget links
   3. Hover-scroller images click through to the product page
   ============================================================ */
(function () {
  var MAP = {
    'black': '#1a1a1a', 'white': '#ffffff', 'ivory': '#fffbef', 'cream': '#f5f0e1', 'champagne': '#f0e6d2', 'nude': '#e3c4a8', 'beige': '#e8dcc8', 'tan': '#d2b48c', 'camel': '#c19a6b', 'taupe': '#b9a89b',
    'brown': '#6f4e37', 'dark-brown': '#4a3526', 'chocolate': '#4e342e', 'cocoa': '#5c4033', 'mocha': '#7b5e57', 'coffee': '#6f4e37', 'espresso': '#3c2f2f', 'caramel': '#b07a45', 'rust': '#b7410e', 'terracotta': '#cc6b49', 'brick': '#9c4a3c',
    'orange': '#e8743b', 'burnt-orange': '#c45c26', 'apricot': '#fbceb1', 'peach': '#ffcba4', 'coral': '#ff7f6e', 'salmon': '#fa8072',
    'red': '#c0392b', 'wine': '#722f37', 'wine-red': '#722f37', 'burgundy': '#800020', 'maroon': '#800000', 'garnet': '#7b1e3b', 'berry': '#8e4585', 'cherry': '#990f2b', 'plum': '#6b3fa0',
    'purple': '#7d4f9e', 'violet': '#8a5fbf', 'lilac': '#c8a2c8', 'lavender': '#b6a4d4', 'fuchsia': '#d63384', 'magenta': '#c2185b',
    'hot-pink': '#e91e8c', 'pink': '#e6a4b4', 'blush': '#f4c2c2', 'dusty-pink': '#d4a5a5', 'dusty-rose': '#c08081', 'rose': '#d87093', 'baby-pink': '#f4c8d8', 'light-pink': '#f6c9d4',
    'baby-blue': '#a8cfe7', 'sky-blue': '#87ceeb', 'light-blue': '#add8e6', 'blue': '#3b5ba5', 'royal-blue': '#2a52be', 'cobalt': '#1f4e9e', 'navy': '#1f2a44', 'navy-blue': '#1f2a44', 'denim': '#4a6792',
    'teal': '#2a7f7f', 'turquoise': '#40c4c4', 'aqua': '#7fd4d4', 'mint': '#aaddcc', 'sage': '#9caf88', 'seafoam': '#a3c9b8',
    'olive': '#6b8e23', 'khaki': '#b7a878', 'green': '#3e7a4f', 'emerald': '#2e8b57', 'forest-green': '#2e5339', 'hunter-green': '#355e3b', 'dark-green': '#2f4f3a', 'lime': '#9acd32',
    'yellow': '#e7c648', 'mustard': '#cda434', 'gold': '#b8943e', 'butter': '#f4e8b0', 'lemon': '#f3e96b',
    'silver': '#c0c0c0', 'grey': '#8c8c8c', 'gray': '#8c8c8c', 'charcoal': '#444444', 'light-grey': '#cfcfcf', 'light-gray': '#cfcfcf', 'stone': '#a8a29a', 'heather-grey': '#a7a7ad',
    'leopard': '#a47551', 'animal': '#a47551', 'multi': '#cccccc', 'floral': '#d9a7b8'
  };

  function handleize(s) {
    return (s || '').toString().trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function lookup(name) {
    var key = handleize(name);
    if (MAP[key]) return MAP[key];
    var parts = key.split('-');
    if (parts.length > 1) {
      var last = parts[parts.length - 1];
      if (MAP[last]) return MAP[last];
      var first = parts[0];
      if (MAP[first]) return MAP[first];
    }
    var probe = new Option().style;
    probe.color = key;
    if (probe.color !== '') return key;
    return null;
  }

  function paint(root) {
    root = root || document;
    var cardSwatches = root.querySelectorAll('.product-card__swatch');
    for (var i = 0; i < cardSwatches.length; i++) {
      var el = cardSwatches[i];
      if (el.__painted) continue; el.__painted = true;
      var hex = lookup(el.getAttribute('title'));
      if (hex) { el.style.backgroundColor = hex; el.removeAttribute('data-swatch-unknown'); }
      else { el.style.backgroundColor = '#e0e0e0'; el.removeAttribute('data-swatch-unknown'); } /* Default color instead of hiding */
    }
    var pdpSwatches = root.querySelectorAll('.color-swatch');
    for (var j = 0; j < pdpSwatches.length; j++) {
      var wrap = pdpSwatches[j];
      var dot = wrap.querySelector('.color-swatch__dot');
      if (!dot) continue;
      if (dot.__painted) continue; dot.__painted = true;
      var nameEl = wrap.querySelector('.color-swatch__name');
      var name = (nameEl && nameEl.textContent) || dot.getAttribute('title') || (wrap.querySelector('input') && wrap.querySelector('input').value);
      var hx = lookup(name);
      if (hx) { dot.style.backgroundColor = hx; dot.removeAttribute('data-swatch-unknown'); }
      else { dot.style.backgroundColor = '#e0e0e0'; dot.removeAttribute('data-swatch-unknown'); } /* Default color instead of hiding */
    }
  }

  /* --- 2. Clickable card swatches --- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('[data-card-swatch]');
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    var card = sw.closest('.product-card');
    if (!card) return;
    // Mark card as having swatch selected to disable hover swap
    card.classList.add('product-card--swatch-selected');
    card.classList.remove('is-swapped'); // Remove swapped state to show primary image
    if (activeCard === card) {
      activeCard = null; // Reset active state tracker
    }
    var img = card.querySelector('.product-card__image--primary');
    var newSrc = sw.getAttribute('data-image');
    if (img && newSrc) {
      img.src = newSrc;
      img.srcset = '';
      var hoverImg = card.querySelector('.product-card__image--hover');
      if (hoverImg) hoverImg.style.display = 'none';
    }
    var url = sw.getAttribute('data-url');
    if (url) {
      var imageLink = card.querySelector('.product-card__image-link');
      var titleLink = card.querySelector('[data-card-title-link]');
      if (imageLink) imageLink.href = url;
      if (titleLink) titleLink.href = url;
    }
    var siblings = card.querySelectorAll('[data-card-swatch]');
    for (var i = 0; i < siblings.length; i++) siblings[i].classList.remove('is-selected');
    sw.classList.add('is-selected');
  }, true);

  /* --- 3. Scroller images click through to the product --- */
  document.addEventListener('click', function (e) {
    if (e.target.closest && (e.target.closest('[data-scroller-prev]') || e.target.closest('[data-scroller-next]') || e.target.closest('[data-scroller-dot]'))) return;
    var slide = e.target.closest && e.target.closest('.product-card__scroller-slide');
    if (!slide) return;
    var card = slide.closest('.product-card');
    var link = card && card.querySelector('.product-card__image-link');
    if (link && link.href) window.location.href = link.href;
  });

  /* --- 4. Hover/Touch Stateful Image Toggle --- */
  var activeCard = null;

  function activateCard(card) {
    if (activeCard && activeCard !== card) {
      activeCard.classList.remove('is-swapped');
    }
    card.classList.toggle('is-swapped');
    if (card.classList.contains('is-swapped')) {
      activeCard = card;
    } else {
      activeCard = null;
    }
  }

  function initHoverToggle(root) {
    root = root || document;
    var cards = root.querySelectorAll('.product-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.__hoverToggleInit) continue;
      card.__hoverToggleInit = true;

      var hoverImg = card.querySelector('.product-card__image--hover');
      if (!hoverImg) continue;

      (function (c) {
        c.addEventListener('mouseenter', function () {
          // Skip hover swap if swatch is already selected
          if (c.classList.contains('product-card--swatch-selected')) return;
          activateCard(c);
        });

        c.addEventListener('mouseleave', function () {
          // Skip if swatch is selected
          if (c.classList.contains('product-card--swatch-selected')) return;
          c.classList.remove('is-swapped');
          if (activeCard === c) {
            activeCard = null;
          }
        });

        var touchStartX = 0;
        var touchStartY = 0;
        var touchMoved = false;

        c.addEventListener('touchstart', function (e) {
          var touch = e.touches[0];
          touchStartX = touch.clientX;
          touchStartY = touch.clientY;
          touchMoved = false;
        }, { passive: true });

        c.addEventListener('touchmove', function (e) {
          var touch = e.touches[0];
          if (Math.abs(touch.clientX - touchStartX) > 10 || Math.abs(touch.clientY - touchStartY) > 10) {
            touchMoved = true;
          }
        }, { passive: true });

        c.addEventListener('touchend', function (e) {
          var target = e.target;
          if (target && target.nodeType === 3) {
            target = target.parentElement;
          }
          if (!target || !target.closest) return;

          var interactive = target.closest('button, [data-card-swatch], [data-card-size], [data-action], form');
          if (interactive) {
            return;
          }

          // If a swatch is selected, don't toggle is-swapped, but tapping navigable parts should navigate
          if (c.classList.contains('product-card--swatch-selected')) {
            if (!touchMoved) {
              var isNavigable = target.closest('.product-card__media') || target.closest('.product-card__title');
              if (isNavigable) {
                var link = c.querySelector('.product-card__image-link');
                if (link && link.href) {
                  e.preventDefault();
                  e.stopPropagation();
                  window.location.href = link.href;
                }
              }
            }
            return;
          }

          if (touchMoved) {
            activateCard(c);
          } else {
            // Only navigate if tapping on navigable elements (image or title)
            var isNavigable = target.closest('.product-card__media') || target.closest('.product-card__title');
            if (isNavigable) {
              var link = c.querySelector('.product-card__image-link');
              if (link && link.href) {
                e.preventDefault();
                e.stopPropagation();
                window.location.href = link.href;
              }
            }
          }
        });
      })(card);
    }
  }

  /* --- 5. Search Drawer Toggle --- */
  function initSearchDrawer() {
    var searchDrawer = document.getElementById('SearchDrawer');
    if (!searchDrawer) return;
    var searchInput = searchDrawer.querySelector('.search-drawer__input');

    function openSearch() {
      searchDrawer.setAttribute('aria-hidden', 'false');
      if (searchInput) {
        setTimeout(function () { searchInput.focus(); }, 150);
      }
    }

    function closeSearch() {
      searchDrawer.setAttribute('aria-hidden', 'true');
      if (searchInput) {
        searchInput.value = '';
      }
    }

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-action="open-search"]');
      if (openBtn) {
        e.preventDefault();
        openSearch();
      }

      var closeBtn = e.target.closest('[data-action="close-search"]');
      if (closeBtn) {
        e.preventDefault();
        closeSearch();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (searchDrawer.getAttribute('aria-hidden') === 'false') {
          closeSearch();
        }
        var quickShopDrawer = document.getElementById('QuickShopDrawer');
        if (quickShopDrawer && quickShopDrawer.getAttribute('aria-hidden') === 'false') {
          var qsClose = quickShopDrawer.querySelector('[data-action="close-quick-shop"]');
          if (qsClose) qsClose.click();
        }
        var quickViewModal = document.getElementById('QuickView');
        if (quickViewModal && quickViewModal.getAttribute('aria-hidden') === 'false') {
          var qvClose = quickViewModal.querySelector('[data-action="close-quick-view"]');
          if (qvClose) qvClose.click();
        }
      }
    });
  }

  /* --- 6. PDP Color Swatch Gallery Sync --- */
  function initSwatchGallerySync() {
    var variantsJsonEl = document.getElementById('ProductVariantsJson');
    if (!variantsJsonEl) return;

    var variants = [];
    try {
      variants = JSON.parse(variantsJsonEl.textContent);
    } catch (e) {
      return;
    }

    var swatchInputs = document.querySelectorAll('.product-info .color-swatch input, .product-info .option-btn input');
    swatchInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var selectedOptions = [];
        var optionContainers = document.querySelectorAll('.product-info .product-option');
        optionContainers.forEach(function (optWrap) {
          var checkedInput = optWrap.querySelector('input[type="radio"]:checked');
          if (checkedInput) {
            selectedOptions.push(checkedInput.value);
          }
        });

        var matchingVariant = variants.find(function (v) {
          return v.options.every(function (opt, index) {
            return opt === selectedOptions[index];
          });
        });

        if (matchingVariant) {
          var varInput = document.getElementById('ProductVariantId');
          if (varInput) varInput.value = matchingVariant.id;

          var priceCurrent = document.querySelector('.product-info__price-current');
          var priceCompare = document.querySelector('.product-info__price-compare');
          var priceSave = document.querySelector('.product-info__price-save');
          var atcBtn = document.querySelector('.product-atc');

          function formatCents(cents) {
            return '$' + (cents / 100).toFixed(2);
          }

          if (priceCurrent) priceCurrent.textContent = formatCents(matchingVariant.price);

          if (priceCompare) {
            if (matchingVariant.compare_at_price && matchingVariant.compare_at_price > matchingVariant.price) {
              priceCompare.style.display = 'inline';
              priceCompare.textContent = formatCents(matchingVariant.compare_at_price);
              if (priceSave) {
                var savedCents = matchingVariant.compare_at_price - matchingVariant.price;
                priceSave.style.display = 'inline';
                priceSave.textContent = 'You save ' + formatCents(savedCents);
              }
            } else {
              priceCompare.style.display = 'none';
              if (priceSave) priceSave.style.display = 'none';
            }
          }

          if (atcBtn) {
            if (matchingVariant.available) {
              atcBtn.disabled = false;
              atcBtn.textContent = 'Add to Cart — ' + formatCents(matchingVariant.price);
            } else {
              atcBtn.disabled = true;
              atcBtn.textContent = 'Sold Out';
            }
          }

          if (history.replaceState) {
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?variant=' + matchingVariant.id;
            window.history.replaceState({ path: newurl }, '', newurl);
          }

          if (matchingVariant.featured_image && matchingVariant.featured_image.src) {
            var variantImgUrl = matchingVariant.featured_image.src;
            var variantBase = variantImgUrl.split('?')[0].split('/').pop();
            var slides = document.querySelectorAll('.product-gallery__slide');
            var thumbs = document.querySelectorAll('.product-gallery__thumb');
            slides.forEach(function (slide, idx) {
              var img = slide.querySelector('img');
              if (img && img.src) {
                var slideBase = img.src.split('?')[0].split('/').pop();
                if (slideBase === variantBase) {
                  slides.forEach(function (s) { s.classList.remove('product-gallery__slide--active'); });
                  thumbs.forEach(function (t) { t.classList.remove('product-gallery__thumb--active'); });
                  slide.classList.add('product-gallery__slide--active');
                  if (thumbs[idx]) {
                    thumbs[idx].classList.add('product-gallery__thumb--active');
                    var thumbContainer = thumbs[idx].closest('.product-gallery__thumbs');
                    if (thumbContainer) {
                      var leftPos = thumbs[idx].offsetLeft;
                      if (thumbs[idx].offsetParent !== thumbContainer) {
                        leftPos = thumbs[idx].getBoundingClientRect().left - thumbContainer.getBoundingClientRect().left + thumbContainer.scrollLeft;
                      }
                      thumbContainer.scrollTo({
                        left: leftPos,
                        behavior: 'smooth'
                      });
                    }
                  }
                }
              }
            });
          }
        }
      });
    });
  }

  // --- 7. Global AJAX Add to Cart for product cards ---
  function initGlobalCardAtc() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-card-atc-form]');
      if (!form) return;
      e.preventDefault();
      e.stopPropagation();

      var atcBtn = form.querySelector('button[type="submit"]');
      var originalText = atcBtn ? atcBtn.textContent : '';
      if (atcBtn) {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding...';
      }

      var idInput = form.querySelector('input[name="id"]');
      var id = idInput ? idInput.value : '';
      if (!id) {
        if (atcBtn) {
          atcBtn.disabled = false;
          atcBtn.textContent = originalText;
        }
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (atcBtn) {
            atcBtn.textContent = 'Added ✓';
          }
          var openCart = document.querySelector('[data-action="open-cart"]');
          if (openCart) openCart.click();

          document.dispatchEvent(new CustomEvent('cart:refresh'));

          setTimeout(function () {
            if (atcBtn) {
              atcBtn.disabled = false;
              atcBtn.textContent = originalText;
            }
          }, 1800);
        })
        .catch(function () {
          if (atcBtn) {
            atcBtn.disabled = false;
            atcBtn.textContent = 'Try Again';
          }
        });
    });
  }

  function initAll() {
    paint();
    initHoverToggle();
    initSearchDrawer();
    initSwatchGallerySync();
    initGlobalCardAtc();
    initCartUpsell();
    initPredictiveSearch();
    // Run initial shipping protection check
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { checkShippingProtection(cart); })
      .catch(function(e) { console.error('Failed to get cart:', e); });
  }

  if (document.readyState !== 'loading') { initAll(); }
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('cards:rendered', function (e) {
    var root = e.detail && e.detail.root;
    paint(root);
    initHoverToggle(root);
    initCartUpsell(root);
  });
  setTimeout(function () { initAll(); }, 1500);
  setTimeout(function () { initAll(); }, 4000);

  // --- Cart Drawer AJAX Refresh & Auto-On Shipping Protection ---
  var isUpdatingProtection = false;

  function refreshCartDrawerHtml() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function(el) { el.textContent = cart.item_count; });
        fetch('/?section_id=cart-drawer')
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var temp = document.createElement('div');
            temp.innerHTML = html;
            var newDrawer = temp.querySelector('.cart-drawer');
            var cartDrawer = document.getElementById('CartDrawer');
            if (newDrawer && cartDrawer) {
              var isOpen = cartDrawer.getAttribute('aria-hidden') === 'false';
              cartDrawer.innerHTML = newDrawer.innerHTML;
              if (isOpen) cartDrawer.setAttribute('aria-hidden', 'false');
              initCartUpsell(cartDrawer);
              checkShippingProtection(cart);
            }
          });
      });
  }

  var observerActive = true;

  function checkShippingProtection(cart) {
    if (isUpdatingProtection) return;
    var container = document.querySelector('.cart-drawer__protection');
    if (!container) return;
    var variantId = parseInt(container.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    var hasProtection = cart.items.some(function(item) { return item.id === variantId; });
    var otherCount = cart.items.reduce(function(acc, item) {
      return item.id !== variantId ? acc + item.quantity : acc;
    }, 0);

    if (otherCount > 0 && !hasProtection && sessionStorage.getItem('shipping_protection_optout') !== 'true') {
      isUpdatingProtection = true;
      observerActive = false;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(function() {
        return fetch('/cart.js').then(function(r) { return r.json(); });
      })
      .then(function(newCart) {
        document.querySelectorAll('[data-cart-count]').forEach(function(el) { el.textContent = newCart.item_count; });
        return fetch('/?section_id=cart-drawer').then(function(r) { return r.text(); });
      })
      .then(function(html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var newDrawer = temp.querySelector('.cart-drawer');
        var cartDrawer = document.getElementById('CartDrawer');
        if (newDrawer && cartDrawer) {
          var isOpen = cartDrawer.getAttribute('aria-hidden') === 'false';
          cartDrawer.innerHTML = newDrawer.innerHTML;
          if (isOpen) cartDrawer.setAttribute('aria-hidden', 'false');
          initCartUpsell(cartDrawer);
        }
        isUpdatingProtection = false;
        setTimeout(function() { observerActive = true; }, 100);
      })
      .catch(function() {
        isUpdatingProtection = false;
        observerActive = true;
      });
    } else if (otherCount === 0 && hasProtection) {
      isUpdatingProtection = true;
      observerActive = false;
      var lineIndex = -1;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].id === variantId) {
          lineIndex = i + 1;
          break;
        }
      }
      if (lineIndex !== -1) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: lineIndex, quantity: 0 })
        })
        .then(function() {
          return fetch('/cart.js').then(function(r) { return r.json(); });
        })
        .then(function(newCart) {
          document.querySelectorAll('[data-cart-count]').forEach(function(el) { el.textContent = newCart.item_count; });
          return fetch('/?section_id=cart-drawer').then(function(r) { return r.text(); });
        })
        .then(function(html) {
          var temp = document.createElement('div');
          temp.innerHTML = html;
          var newDrawer = temp.querySelector('.cart-drawer');
          var cartDrawer = document.getElementById('CartDrawer');
          if (newDrawer && cartDrawer) {
            var isOpen = cartDrawer.getAttribute('aria-hidden') === 'false';
            cartDrawer.innerHTML = newDrawer.innerHTML;
            if (isOpen) cartDrawer.setAttribute('aria-hidden', 'false');
            initCartUpsell(cartDrawer);
          }
          isUpdatingProtection = false;
          setTimeout(function() { observerActive = true; }, 100);
        })
        .catch(function() {
          isUpdatingProtection = false;
          observerActive = true;
        });
      } else {
        isUpdatingProtection = false;
        observerActive = true;
      }
    }
  }

  function initCartUpsell(root) {
    root = root || document;
    var slider = root.querySelector('[data-upsell-slider]');
    if (!slider) return;
    var dots = root.querySelectorAll('[data-upsell-dot]');
    if (!dots.length) return;

    slider.addEventListener('scroll', function() {
      var index = Math.round(slider.scrollLeft / slider.clientWidth);
      dots.forEach(function(dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }, { passive: true });

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var index = parseInt(this.getAttribute('data-upsell-dot'), 10);
        slider.scrollTo({ left: index * slider.clientWidth, behavior: 'smooth' });
      });
    });
  }

  // Predictive search real-time previews autocomplete dropdown
  function initPredictiveSearch() {
    var searchInput = document.querySelector('.search-drawer__input');
    if (!searchInput) return;

    var form = searchInput.closest('form');
    if (!form) return;

    var dropdown = form.querySelector('.predictive-search');
    if (!dropdown) {
      dropdown = document.createElement('div');
      dropdown.className = 'predictive-search';
      dropdown.style.display = 'none';
      form.appendChild(dropdown);
    }

    var debounceTimeout;

    searchInput.addEventListener('input', function() {
      clearTimeout(debounceTimeout);
      var query = searchInput.value.trim();

      if (query.length <= 2) {
        dropdown.innerHTML = '';
        dropdown.style.display = 'none';
        return;
      }

      debounceTimeout = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=5')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var products = data.resources && data.resources.results && data.resources.results.products;
            if (products && products.length > 0) {
              var html = '';
              products.forEach(function(product) {
                var priceFormatted = product.price;
                if (!priceFormatted.includes('$')) {
                  priceFormatted = '$' + parseFloat(priceFormatted).toFixed(2);
                }
                html += '<a href="' + product.url + '" class="predictive-search__item">' +
                  (product.image ? '<img src="' + product.image + '" class="predictive-search__item-image" alt="' + product.title + '">' : '') +
                  '<div class="predictive-search__item-details">' +
                    '<span class="predictive-search__item-title">' + product.title + '</span>' +
                  '</div>' +
                  '<span class="predictive-search__item-price">' + priceFormatted + '</span>' +
                '</a>';
              });
              dropdown.innerHTML = html;
              dropdown.style.display = 'block';
            } else {
              dropdown.innerHTML = '<div style="padding: 1rem; text-align: center; font-size: 0.875rem; color: #7a7977;">No results found</div>';
              dropdown.style.display = 'block';
            }
          })
          .catch(function(err) {
            console.error('Predictive search failed:', err);
          });
      }, 250);
    });

    document.addEventListener('click', function(e) {
      if (!form.contains(e.target)) {
        dropdown.style.display = 'none';
      }
    });
  }

  // Event listener for cart refresh events triggered globally
  document.addEventListener('cart:refresh', refreshCartDrawerHtml);

  // Upsell Add action delegation
  document.addEventListener('click', function(e) {
    var btn = e.target.closest && e.target.closest('[data-action="add-upsell"]');
    if (!btn) return;
    e.preventDefault();
    var item = btn.closest('.upsell-item');
    if (!item) return;
    var variantInput = item.querySelector('[data-upsell-variant-select]');
    var variantId = variantInput ? parseInt(variantInput.value, 10) : null;
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      btn.textContent = 'Added ✓';
      refreshCartDrawerHtml();
    })
    .catch(function() {
      btn.disabled = false;
      btn.textContent = 'Try Again';
    });
  });

  // Shipping Protection toggle change delegation
  document.addEventListener('change', function(e) {
    if (e.target && e.target.id === 'ShippingProtectionToggle') {
      var checked = e.target.checked;
      var container = e.target.closest('.cart-drawer__protection');
      if (!container) return;
      var variantId = parseInt(container.getAttribute('data-variant-id'), 10);
      if (!variantId) return;

      isUpdatingProtection = true;
      observerActive = false;
      if (checked) {
        sessionStorage.removeItem('shipping_protection_optout');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
        .then(function() {
          isUpdatingProtection = false;
          refreshCartDrawerHtml();
          setTimeout(function() { observerActive = true; }, 100);
        })
        .catch(function() {
          isUpdatingProtection = false;
          observerActive = true;
        });
      } else {
        sessionStorage.setItem('shipping_protection_optout', 'true');
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var lineIndex = -1;
            for (var i = 0; i < cart.items.length; i++) {
              if (cart.items[i].id === variantId) {
                lineIndex = i + 1;
                break;
              }
            }
            if (lineIndex !== -1) {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ line: lineIndex, quantity: 0 })
              });
            }
          })
          .then(function() {
            isUpdatingProtection = false;
            refreshCartDrawerHtml();
            setTimeout(function() { observerActive = true; }, 100);
          })
          .catch(function() {
            isUpdatingProtection = false;
            observerActive = true;
          });
      }
    }
  });

  // Mutation observer to monitor cart drawer updates (for removals and updates in theme.js)
  var observer = new MutationObserver(function() {
    if (!observerActive) return;
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        checkShippingProtection(cart);
      });
  });
  var drawer = document.getElementById('CartDrawer');
  if (drawer) {
    observer.observe(drawer, { childList: true, subtree: true });
  }
})();
